export default {
    computed:{
        breakPoint(){
            const vm = this
            return vm.$vuetify.breakpoint.name
        }
    }
}
